import { Box } from '@chakra-ui/react';
import { MenuCategoryHeaderView } from './components/MenuCategoryHeaderView';
import { MenuCategoryDeleteModal } from './containers/MenuCategoryDeleteModal';
import { MenuCategoryList } from './containers/MenuCategoryList';
import { MenuCategoryModal } from './containers/MenuCategoryModal';
import { MenuCategoryRegistrationModal } from './containers/MenuCategoryRegistrationModal';
import { MenuDeleteModal } from './containers/MenuDeleteModal';
import { MenuModal } from './containers/MenuModal';
import { MenuRegistrationModal } from './containers/MenuRegistrationModal';

export const MenuCategoryPageView = () => (
  <>
    <Box m="40px">
      <MenuCategoryHeaderView />
      <MenuCategoryList />
    </Box>
    <MenuCategoryRegistrationModal />
    <MenuCategoryModal />
    <MenuCategoryDeleteModal />
    <MenuRegistrationModal />
    <MenuModal />
    <MenuDeleteModal />
  </>
);
